<div class="gap-x-6 flex flex-wrap p-3">
  @if (showFileName()) {
    <div class="flex flex-col gap-0.5">
      <span class="text-outline text-xs font-semibold">Nome file</span>
      <span class="text-sm font-medium truncate" [title]="file()?.name">{{
        file()?.name
      }}</span>
    </div>
  }

  <div class="flex flex-col gap-0.5">
    <span class="text-outline text-xs font-semibold">Data ult. modifica</span>
    <span class="text-sm">{{
      file()?.lastModifiedDate
        ? (file()?.lastModifiedDate | date: 'dd/MM/yy HH:mm')
        : '—'
    }}</span>
  </div>
  <div class="flex flex-col gap-0.5">
    <span class="text-outline text-xs font-semibold">Data creazione</span>
    <span class="text-sm">{{
      file()?.creationDate
        ? (file()?.creationDate | date: 'dd/MM/yy HH:mm')
        : '—'
    }}</span>
  </div>

  <div class="flex flex-col gap-0.5">
    <span class="text-outline text-xs font-semibold">Dimensione</span>
    <span class="text-sm">{{
      file()?.size ? (file()?.size | convertBytes) : '—'
    }}</span>
  </div>

  <div class="flex flex-col gap-0.5">
    <span class="text-outline text-xs font-semibold">Categorie</span>
    <div class="flex flex-wrap gap-1">
      @if (file()?.categories && file()!.categories!.length > 0) {
        @for (category of file()?.categories; track $index) {
          <div
            [style.background]="category?.color || '#17749cff'"
            [colorContrastAuto]="true"
            contrastMode="adaptive"
            class="flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-bold"
          >
            <mat-icon class="!h-4 !w-4 !text-sm">{{
              category?.icon || 'folder'
            }}</mat-icon>
            <span>{{ category?.description || category?.id || '' }}</span>
          </div>
        }
      } @else {
        <span class="text-sm">—</span>
      }
    </div>
  </div>
  @for (
    entry of getExtractedPropertiesEntries(file()?.completeExtractedProperties);
    track entry.key
  ) {
    @if (entry.value.value | hasExtractedValue) {
      <!-- Extracted Properties Loop -->
      <div
        class="flex max-w-[calc(50%-1.5rem)] flex-col gap-0.5 truncate"
        [class.w-full]="entry.value.fill_row == true"
        [class.!max-w-full]="entry.value.fill_row == true"
      >
        <span class="text-outline text-xs font-semibold">{{ entry.key }}</span>
        <span class="max-w-full text-sm truncate">{{
          entry.value.value | formatExtractedValue
        }}</span>
      </div>
    }
  }
</div>
